import { StateCreator } from 'zustand'

import { MOCK_GANTT_CHART_DATA } from 'Data/GanttChart'

export interface IGanttChartSlice {
  tasks: any[]
  setTasks: (tasks: any[]) => void
  getTasks: (projectId: string) => Promise<void>
}

export const createGanttChartSlice: StateCreator<IGanttChartSlice, [], []> = (set, get) => ({
  tasks: [],
  setTasks: tasks => set({ tasks }),
  getTasks: async (projectId: string) => {
    set({ tasks: MOCK_GANTT_CHART_DATA })
  },
})
